import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { ErrorBoundary } from 'react-error-boundary'
import { Suspense } from 'react'
import { useQuery } from 'react-query'
import { api } from '../../../services/api'
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'

async function fetchPedidoCompra() {
  const { data } = await api.get('/site/v2/crm-controle/lista-pedido-compra')
  return data
}

export function ImpressaoPedidoCompra() {
  const { data: pedidoCompra, error } = useQuery(
    {
      queryFn: fetchPedidoCompra,
      queryKey: 'pedido-compra',
    },
    {
      suspense: true,
    }
  )

  console.log(pedidoCompra)

  function Fallback({ error, resetErrorBoundary }) {
    return (
      <div role="alert">
        <p>Something went wrong:</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    )
  }

  return (
    <>
      <HeadingPages name="Impressão de Pedido de Compra" />

      <TableContainer
        maxW={1120}
        mx="auto"
        mt="6"
        bg="white"
        borderRadius={8}
        boxShadow="0 0 60px rgba(0, 0, 0, 0.05)"
        w="100%"
      >
        <Table size="sm" colorScheme="blue">
          <Thead>
            <Tr>
              <Th>Numero Nota</Th>
              <Th>Nome Parceiro</Th>
              <Th>Link PDF</Th>
            </Tr>
          </Thead>
          <Tbody>
            <ErrorBoundary FallbackComponent={Fallback} onReset={() => {}}>
              <Suspense fallback={<h1>Carregando...</h1>}>
                {(() => {
                  try {
                    return pedidoCompra?.map((pedido) => (
                      <Tr key={pedido.id}>
                        <Td>{pedido.numero_nota}</Td>
                        <Td>{pedido.nome_parceiro}</Td>
                        <Td>
                          <Text
                            as="a"
                            color="blue.500"
                            _hover={{ color: 'blue.600' }}
                            href={pedido.link_pdf}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Link pdf
                          </Text>
                        </Td>
                      </Tr>
                    ))
                  } catch (error) {
                    throw error
                  }
                })()}
              </Suspense>
            </ErrorBoundary>
          </Tbody>
        </Table>
      </TableContainer>
    </>
  )
}
